import HeaderedList from "@/components/headered-list/headered-list";
import { Bestek } from "@/models/bestek";

interface Props {
    bestek: Bestek
}

export default function BestekGeneralInfo(props: Props) {
    const items: { label: string, value: string }[] = [
        { label: "Beschrijving:", value: props.bestek.beschrijving },
        { label: "Versie:", value: props.bestek.versie },
        { label: "Versie jaarversie:", value: props.bestek.versie_jaarversie },
        { label: "Aanmaakdatum:", value: props.bestek.aanmaak_datum },
        { label: "Laatste wijziging:", value: props.bestek.wijzigings_datum },
        { label: "Ontgrendelcode:", value: props.bestek.ontgrendel_code },
        { label: "Nummer:", value: props.bestek.nummer },
        { label: "Registratienummer:", value: props.bestek.registratie_nummer }
    ];

    if (props.bestek.algemene_info) {
        items.push(
            { label: "Beschrijving:", value: props.bestek.algemene_info.beschrijving },
            { label: "Opdrachtgever:", value: props.bestek.algemene_info.opdrachtgever },
            { label: "Directie:", value: props.bestek.algemene_info.directie },
            { label: "Tijdsbepaling:", value: props.bestek.algemene_info.tijdsbepaling },
            { label: "Onderhoudstermijn:", value: props.bestek.algemene_info.onderhoudstermijn }
        )
    }

    return (
        <HeaderedList title="Algemene informatie" items={items} />
    )
}